import React, { PropsWithChildren } from 'react';


interface Props {

}
const AccountInfoContainer = (props: PropsWithChildren<Props>) => {
 

    return (
        <>
            {props.children}
        </>
    );
};

export default AccountInfoContainer;